import { useState } from "react";
import { PhoneMissed } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/common";

export const AttemptsBox = ({ t, max, onSaved }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const n = t.call_attempts || 0;
  const log = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/followups/${t.id}/attempt`, { note });
      toast.success(`Unanswered call ${data.call_attempts} logged`);
      setNote("");
      onSaved(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="attempts-box" className="rounded-xl border border-amber-200 bg-amber-50/60 p-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-sm font-semibold text-amber-900">Customer didn't pick up?</div>
        <span data-testid="attempts-count" className="text-xs font-semibold text-amber-700">{n} of {max} unanswered calls</span>
      </div>
      {n < max ? (
        <div className="mt-3 flex flex-col gap-2 sm:flex-row">
          <Input data-testid="attempt-note-input" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (optional), e.g. switched off" className="h-10 rounded-xl bg-white" />
          <Button variant="outline" onClick={log} disabled={busy} className="h-10 shrink-0 rounded-xl border-amber-300 bg-white" data-testid="log-attempt-button">
            {busy ? <Spinner className="mr-2 h-4 w-4" /> : <PhoneMissed className="mr-2 h-4 w-4" />}Log unanswered call
          </Button>
        </div>
      ) : (
        <p className="mt-2 text-sm text-amber-800">Tried {max} times. You can close this ticket now, or still save the call below if the customer calls back.</p>
      )}
      {!!(t.call_log || []).length && (
        <ul className="mt-3 space-y-1 text-xs text-amber-900/80" data-testid="attempts-log">
          {t.call_log.map((c, i) => <li key={c.at}>Call {i + 1} · {fmtDateTime(c.at)}{c.note ? ` · ${c.note}` : ""}</li>)}
        </ul>
      )}
    </div>
  );
};
